import { FC } from "react";
import { SidebarLinkPathTypes, SidebarLinkTypes } from "../../LinkTypes";
import { BaseComplexSidebarLink, ComplexLinkProps } from "./BaseComplexSidebarLink";
import { ReceiptLongIcon } from "../../../../assets/icons/Icons";
import { useTranslation } from "react-i18next";

const sidebarLinks = [
  { linkName: SidebarLinkTypes.invoices, path: SidebarLinkPathTypes.invoices },
  { linkName: SidebarLinkTypes.analysisFilesNewEmployees, path: SidebarLinkPathTypes.analysisFilesNewEmployees },
  { linkName: SidebarLinkTypes.analysisFilesBoughtVouchers, path: SidebarLinkPathTypes.analysisFilesBoughtVouchers },
  { linkName: SidebarLinkTypes.analysisFilesUpcomingBonusRewards, path: SidebarLinkPathTypes.analysisFilesUpcomingBonusRewards },
  { linkName: SidebarLinkTypes.analysisFilesDirectPayout, path: SidebarLinkPathTypes.analysisFilesDirectPayout },
  { linkName: SidebarLinkTypes.analysisFilesCompanyPension, path: SidebarLinkPathTypes.analysisFilesCompanyPension },
];

export const AnalysisFilesComplexLink: FC<ComplexLinkProps> = ({ activePathname, collapsed, showText }) => {
  const { t } = useTranslation();
  return (
    <BaseComplexSidebarLink
      activePathname={activePathname}
      collapsed={collapsed}
      showText={showText}
      icon={<ReceiptLongIcon />}
      label={t(SidebarLinkTypes.analysisFiles)}
      links={sidebarLinks}
    />
  );
};
